import { __assign, __extends } from "tslib";
import React from "react";
var SVG = /** @class */ (function (_super) {
    __extends(SVG, _super);
    function SVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SVG.prototype.render = function () {
        return React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "36", height: "37", viewBox: "0 0 36 37" }, this.props),
            React.createElement("path", { className: "cls-1", d: "M16.47 33.13a16.575 16.575 0 1 1 16.47-16.57 16.538 16.538 0 0 1-16.47 16.57zm0-31.75a15.18 15.18 0 1 0 15.09 15.18A15.144 15.144 0 0 0 16.47 1.38zm18.51 35.61l-8.61-9.48 1.02-.94L36 36.04z" }));
    };
    return SVG;
}(React.Component));
export default SVG;
